import React, {useState, Fragment} from 'react'

// Material-UI Core
import {makeStyles, withStyles, useTheme} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'

// Material-UI Icon
import CloseIcon from '@material-ui/icons/Close'

// Custom Style
import {normalDialogStyle, dialogTitleStyles} from '../../styles/jss/components/dialog/normalDialogStyle'


const useStyles = makeStyles(theme => normalDialogStyle(theme))

const DialogTitle = withStyles(dialogTitleStyles)((props) => {
	const {children, classes, onClose, ...other} = props
	
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
		<Typography variant="h6">{children}</Typography>
		{onClose ? (
			<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
			<CloseIcon />
			</IconButton>
		) : null}
		</MuiDialogTitle>
	)
})

// const CustomButton = withStyles({
// 	root: {
// 		color: 'white',
// 	},
// })(Button)

const NormalDialog = props => {
	const {open, dialogTitle, formContent, size, height, button, handleClose} = props
	const classes = useStyles()
	const theme = useTheme()
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

	const [fullWidth, setFullWidth] = useState(true)
	const [maxWidth, setMaxWidth] = useState(size)

	return (
		<Fragment>
			<Dialog
				aria-labelledby="search-dialog"
				fullScreen={fullScreen}
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				open={open}
				onClose={handleClose}
				disableBackdropClick={true}
			>
				<DialogTitle id="search-dialog-title" onClose={handleClose}	className={classes.headerFooter}>
					{dialogTitle}
				</DialogTitle>

				<DialogContent dividers >
					<DialogContentText component={"div"}>
						<div style={{"height": height}}>
							{formContent}
						</div>
					</DialogContentText>
				</DialogContent>

				<DialogActions className={classes.headerFooter}>
					{
						button.map((x, key) => {
							return (
								(x.chooseFile)
								?
								<label htmlFor={"normal-dialog-btn-" + x.buttonName} key={key}>
									<input
										multiple
										id={"normal-dialog-btn-" + x.buttonName}
										type="file"
										style={{display:"none"}}
										// onChange={onChange}
									/>

									<Button component="span" color="inherit" variant="outlined" size="small">
										{x.buttonName}
									</Button>
								</label>
								:
								<Button component="span" color="inherit" variant="outlined" size="small" key={key} onClick={x.buttonFunction != null ? x.buttonFunction : null} className={classes.searchBtn}>
									{x.buttonName}
								</Button>
							)
						})
					}
				</DialogActions>
			</Dialog>
		</Fragment>
	)
}


export default NormalDialog